<div style="display: flex;">
    <mat-form-field>
        <mat-label>Type here to search...</mat-label>
        <input
            matInput
            type="text"
            [(ngModel)]="query"
            (ngModelChange)="filterResults()"
        />
    </mat-form-field>
    <!-- <mat-icon (click)="clearIcon()">clear</mat-icon> -->
</div>

<div class="icon-container">
    @for (icon of searchIcons; track icon) {
        <button mat-icon-button (click)="setIcon(icon)">
            <mat-icon
                [fontIcon]="icon"
                [style.color]="
                    theme.value == 'dark'
                        ? icon == page?.icon ? '#fff' : '#eee'
                        : icon == page?.icon ? '#000' : '#111'
                "
            />
        </button>
    }
</div>



